'use client'
import {
  context_default
} from "./chunk-HDMRRVS3.mjs";

// src/context/root/useCurrency.ts
import { useContext } from "react";
var useCurrency = () => {
  const context = useContext(context_default);
  return context;
};
var useCurrency_default = useCurrency;

export {
  useCurrency,
  useCurrency_default
};
//# sourceMappingURL=chunk-XPA6WW2H.mjs.map